function encodeRFC3986URIComponent(str: string) {
    return encodeURIComponent(str).replace(
        /[!'()*]/g,
        (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`,
    );
}

export default encodeRFC3986URIComponent;
